import React, { useEffect } from "react";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { JobTrackerListingType } from "../../../redux/listing/listingTypes";
import moment from "moment";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import "./JobTableData.scss";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";
import {
  BlueFlagIcon,
  CheckCircleDarkIcon,
  DisableJobClosureIcon,
  GreenFlagIcon,
  GreyFlagIcon,
  LinkAttach,
  PendingIcon,
  RedFlagIcon,
  SendForJobClosureIcon,
  ShareIcon,
  commentIcon,
} from "../../../assets/images";
import { GovtOfficerJobsListType, LoginResponseType } from "../../../redux/auth/authTypes";

type AppProps = {
  jobData: JobTrackerListingType[] | GovtOfficerJobsListType[];
  tableHeader: TableHeadersType[];
  handleSetJobsData?: (data: any, type: string) => void;
  handleToggleProgressCommentsModal?: () => void;
  handleToggleLinkUploadModal?: () => void;
  isAdminReport?: boolean;
  isSuperAdmin?: boolean;
  shareJobList?: boolean;
  isSentForJobClosureActionPresent?: boolean;
  getJobId?: any;
  type?: string;
  tab?: string;
  handleChecklistModal?: (data: JobTrackerListingType) => void;
  getShareJobId?: (id: number) => void;
  handleToggleShareJobModal?: () => void;
  jobApprovalPending?: boolean;
  handleSentJobForClosuring?: (data: any) => void;
  loginData?: LoginResponseType | undefined;
  handleApproveAndSendModal?: (data: any) => void;
  isSingleCheckListPresent?: boolean;
  commentDueTomorrow?:boolean;
};

const JobTableData = ({
  jobData,
  tableHeader,
  isAdminReport,
  isSuperAdmin,
  getJobId,
  type,
  shareJobList,
  loginData,
  tab,
  isSentForJobClosureActionPresent,
  handleChecklistModal,
  getShareJobId,
  handleToggleShareJobModal,
  handleSetJobsData,
  handleToggleProgressCommentsModal,
  handleToggleLinkUploadModal,
  jobApprovalPending,
  handleSentJobForClosuring,
  handleApproveAndSendModal,
  isSingleCheckListPresent,
  commentDueTomorrow
}: AppProps) => {
  let todayDate = moment(new Date()).format("DD-MM-YYYY");
  //========== User Management==========//
  const [isAddJobProgressCommentsPresent, setIsAddJobProgressCommentsPresent] =
    useMenuCheck();
  const [isJobDocumentPresent, setIsJobDocumentPresent] = useMenuCheck();
  //====================//

  useEffect(() => {
    setIsAddJobProgressCommentsPresent("Add Job Progress comments", "menu");
    setIsJobDocumentPresent("Add Job Document", "menu");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderSummaryTooltip = (props: any, data: any) => {
    return (
      <Tooltip id="button-view-open-item" {...props}>
        {data}
      </Tooltip>
    );
  };
  const getStatusStyle = (status: any) => {
    switch (status) {
      case 0:
        return notStartedStyle();
      case 1:
        return awaitingApprovalStyle();
      case 2:
        return reworkRequestedStyle();
      case 3:
        return sendForApprvalTypeStyle();
      default:
        return {};
    }
  };
  const sendForApprvalTypeStyle = () => {
    return {
      padding: "4px 10px",
      color: "#82b01f",
      background: "#e7f0d4",
      borderRadius: "16px",
    };
  };
  const awaitingApprovalStyle = () => {
    return {
      background: "#faedd8",
      borderRadius: "16px",
      padding: "4px 10px",
      color: "#f3a119",
    };
  };
  const reworkRequestedStyle = () => {
    return {
      background: "#fde0d3",
      borderRadius: "16px",
      padding: "4px 10px",
      color: "#e7733e",
    };
  };
  const notStartedStyle = () => {
    return {
      background: "#d7e0f1",
      borderRadius: "16px",
      padding: "4px 10px",
      color: "#262a44",
    };
  };
  const renderTableData = () => {
    let finalTableData = jobData?.map(
      (dataItem: JobTrackerListingType | any) => {
        const checkEndDate = dataItem?.target_end_date
          ?.split("-")
          .reverse()
          .join(",");
        const checkToday = todayDate.split("-").reverse().join(",");

        let targetEndDate = dataItem?.target_end_date ? (
          <span>{dataItem?.target_end_date}</span>
        ) : (
          <span>--/--</span>
        );

        if (
          !isAdminReport &&
          dataItem?.job_status === "Open" &&
          new Date(checkEndDate) < new Date(checkToday)
        ) {
          targetEndDate = (
            <span
              className={dataItem?.target_end_date ? "status-Rejected" : ""}
            >
              {dataItem?.target_end_date ? dataItem?.target_end_date : "--/--"}
            </span>
          );
        } else if (
          isAdminReport &&
          new Date(checkEndDate) < new Date(checkToday)
        ) {
          targetEndDate = (
            <span
              className={dataItem?.target_end_date ? "status-Rejected" : ""}
            >
              {dataItem?.target_end_date ? dataItem?.target_end_date : "--/--"}
            </span>
          );
        }

        const finalComment =
          dataItem?.last_comment?.comment?.length > 15
            ? `${dataItem?.last_comment?.comment?.slice(0, 15)}...`
            : dataItem?.last_comment?.comment;

        const jobDetails = `${dataItem?.job_id}_${dataItem?.job_type}_${dataItem?.period_ended}`;

        const jobsLinkCount = dataItem?.link_count;
        const jobCommentLink = dataItem?.comment_count;

        return (
          <tr key={dataItem?.job_id}>
            {tableHeader?.length &&
              tableHeader?.map((header: TableHeadersType | any) => {
                if (header.value === "job_type") {
                  return (
                    <td onClick={() => getJobId && getJobId(dataItem)}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "left",
                          alignItems: "start",
                          gap: "7px",
                        }}
                      >
                        {commentDueTomorrow ? 
                        <>
                           <span
                        >
                          {jobDetails}
                        </span>
                        </>:
                        <span
                          className={type == "underline" ? "jobTypeTd" : ""}
                          style={
                            type === "underline"
                              ? {
                                  textDecoration: "underline",
                                  fontWeight: "600",
                                }
                              : {}
                          }
                        >
                          {jobDetails}
                        </span>
                }
                        <span>
                          {dataItem?.job_priority === "normal" ? (
                            <img src={GreyFlagIcon} alt="grey" />
                          ) : dataItem?.job_priority === "red" ? (
                            <img src={RedFlagIcon} alt="red" />
                          ) : dataItem?.job_priority === "green" ? (
                            <img src={GreenFlagIcon} alt="green" />
                          ) : dataItem?.job_priority === "blue" ? (
                            <img src={BlueFlagIcon} alt="blue" />
                          ) : (
                            ""
                          )}
                        </span>
                      </div>
                    </td>
                  );
                } else if (header.value === "name") {
                  return (
                    <td>
                      {/* {dataItem?.client_details ? ({`${dataItem?.client_details?.company_name}(${dataItem?.client_details?.client_code})`}) : (`${dataItem?.client_name}(${dataItem?.client_code})`)} */}
                      {dataItem?.client_details 
                      ? `${dataItem?.client_details?.company_name} (${dataItem?.client_details?.client_code})` 
                      : `${dataItem?.client_name} (${dataItem?.client_code})`}

                    </td>
                  );
                } else if (header.value === "client_code") {
                  return (
                    <td>
                      {`${dataItem?.client_details?.company_name}(${dataItem?.client_details?.client_code})`}
                    </td>
                  );
                } else if (header.value === "target_end_date") {
                  return <td style={{ minWidth: "140px" }}>{targetEndDate}</td>;
                } else if (header.value === "currently_responsible") {
                  return (
                    <td style={{ width: "100px" }}>
                      {dataItem?.currently_responsible}
                    </td>
                  );
                } else if (header.value === "job_manager") {
                  return (
                    <td style={{ width: "100px" }}>{dataItem?.job_manager}</td>
                  );
                } else if (header.value === "checklist_status") {
                  return (
                    <td style={{ minWidth: "145px" }}>
                      <span className="pr-1">
                        <span className="mr-2">
                          <img
                            width={18}
                            src={
                              dataItem?.completed_checklist_count <
                              dataItem?.total_checklists
                                ? PendingIcon
                                : CheckCircleDarkIcon
                            }
                            alt="progess"
                          />
                        </span>

                        <span>
                          {dataItem?.completed_checklist_count}/
                          {dataItem?.total_checklists}
                        </span>
                      </span>
                      {isSingleCheckListPresent ? (
                        <div
                          onClick={
                            dataItem?.completed_checklist_count === 0 &&
                            dataItem?.total_checklists === 0
                              ? undefined
                              : () =>
                                  handleChecklistModal &&
                                  handleChecklistModal(dataItem)
                          }
                          className="job_table_checklist_text mt-1"
                          style={{
                            cursor:
                              dataItem?.completed_checklist_count === 0 &&
                              dataItem?.total_checklists === 0
                                ? "not-allowed"
                                : "pointer",
                          }}
                        >
                          {dataItem?.completed_checklist_count === 0 &&
                          dataItem?.total_checklists === 0
                            ? "No Check-List found"
                            : "View all checklists"}
                        </div>
                      ) : (
                        ""
                      )}
                    </td>
                  );
                } else if (header.value === "charged_vs_scheduled") {
                  return (
                    <td>
                      <span className="pr-1">
                        {dataItem?.total_charged_hours?.toFixed(2)} Hrs
                      </span>
                      <span style={{ fontSize: "12px", color: "#6E7491" }}>
                        vs
                      </span>
                      <span
                        className="pl-1"
                        style={{ fontSize: "12px", color: "#6E7491" }}
                      >
                        {dataItem?.total_scheduled_hours?.toFixed(2)} Hrs
                      </span>
                    </td>
                  );
                } else if (header.value === "job_details") {
                  return <td>{dataItem?.job_description}</td>;
                } else if (header.value === "current_job_state") {
                  return (
                    <td className="text-center">
                      <div
                        className={`status-chip ${
                          dataItem?.job_status === "Open"
                            ? "success"
                            : "warning"
                        }`}
                      >
                        {dataItem?.job_status}
                      </div>
                    </td>
                  );
                } else if (header.value === "internal_status") {
                  return (
                    <td className="text-center" style={{ minWidth: "190px" }}>
                      <div style={getStatusStyle(dataItem?.internal_status)}>
                        {dataItem?.internal_status === 0
                          ? "Not Started"
                          : dataItem?.internal_status === 1
                          ? "Awaiting Approval"
                          : dataItem?.internal_status === 2
                          ? "Rework Requested"
                          : dataItem?.internal_status === 3
                          ? "Sent for Closure"
                          : ""}
                      </div>
                    </td>
                  );
                } else if (header.value === "first_name") {
                  return (
                    <td className="text-center" style={{ width: "100px" }}>
                      {dataItem?.last_comment?.commented_by_name}
                    </td>
                  );
                } else if (header.value === "comments") {
                  return (
                    <>
                      <OverlayTrigger
                        placement="top"
                        delay={{ show: 250, hide: 250 }}
                        overlay={renderSummaryTooltip(
                          "",
                          dataItem?.last_comment?.comment
                        )}
                      >
                        <td>
                          {dataItem?.last_comment?.comment?.length ? (
                            <>
                              {finalComment}
                              <br />
                              <span className="due-date-text">
                                {moment
                                  .utc(dataItem?.last_comment?.commented_at)
                                  .local()
                                  .format("DD-MM-YYYY, h:mm a")}
                              </span>
                            </>
                          ) : (
                            <span className="text-center">--/--</span>
                          )}
                        </td>
                      </OverlayTrigger>
                    </>
                  );
                } else if (header.value === "action") {
                  return (
                    <td
                      key={dataItem?.job_id}
                      className="px-3 position-relative"
                      style={{
                        width: shareJobList === true ? "70px" : "120px",
                      }}
                    >
                      <div className="d-flex justify-content-center">
                        <div className="pointer">
                          {isSuperAdmin && dataItem?.job_status === "Open" && (
                            <span
                              onClick={() => {
                                getShareJobId?.(dataItem);
                                handleToggleShareJobModal?.();
                              }}
                            >
                              <img src={ShareIcon} alt="share" />
                            </span>
                          )}
                        </div>
                        {!jobApprovalPending ? (
                          <>
                          {!commentDueTomorrow ? 
                            <div className="pointer">
                              {!shareJobList === true && jobsLinkCount > 0 ? (
                                <span className="jobs-link-count">
                                  {jobsLinkCount}
                                </span>
                              ) : (
                                <></>
                              )}
                              <span className="d-flex flex-row">
                                {isJobDocumentPresent &&
                                  !shareJobList === true && (
                                    <img
                                      src={LinkAttach}
                                      onClick={() => {
                                        handleToggleLinkUploadModal?.();
                                        handleSetJobsData?.(
                                          dataItem,
                                          "documents"
                                        );
                                      }}
                                      alt="link"
                                    ></img>
                                  )}
                              </span>
                            </div>
                :''}
                            <div>
                              {jobCommentLink > 0 && (
                                <span
                                  className="jobs-link-count"
                                  style={{ marginLeft: "20px" }}
                                >
                                  {jobCommentLink}
                                </span>
                              )}
                              <span className="d-flex justify-content-center pointer">
                                {isAddJobProgressCommentsPresent && (
                                  <>
                                    <img
                                      className="ml-2"
                                      src={commentIcon}
                                      onClick={() => {
                                        handleToggleProgressCommentsModal?.();
                                        handleSetJobsData?.(
                                          dataItem,
                                          "comments"
                                        );
                                      }}
                                      alt="comment"
                                    ></img>
                                  </>
                                )}
                              </span>
                            </div>
                          </>
                        ) : (
                          ""
                        )}
                        {/*  */}
                        {jobApprovalPending ? (
                          <div>
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="send-email-tooltip">
                                  Send For Approval
                                </Tooltip>
                              }
                            >
                              <span className="d-flex justify-content-center pointer">
                                {
                                  <div
                                    className="d-flex"
                                    style={{ textAlign: "center" }}
                                  >
                                    {isSentForJobClosureActionPresent &&
                                      dataItem?.job_manager_id !==
                                        loginData?.user_id && (
                                        <img
                                          className="ml-2"
                                          src={
                                            dataItem?.internal_status === 2 ||
                                            dataItem?.internal_status === 0
                                              ? SendForJobClosureIcon
                                              : DisableJobClosureIcon
                                          }
                                          onClick={() => {
                                            if (
                                              dataItem?.internal_status === 2 ||
                                              dataItem?.internal_status === 0
                                            ) {
                                              handleSentJobForClosuring?.(
                                                dataItem
                                              );
                                            }
                                          }}
                                          style={{
                                            cursor:
                                              dataItem?.internal_status === 2 ||
                                              dataItem?.internal_status === 0
                                                ? "pointer"
                                                : "not-allowed",
                                          }}
                                          alt="job closure"
                                        ></img>
                                      )}
                                  </div>
                                }
                              </span>
                            </OverlayTrigger>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </td>
                  );
                } else if (dataItem[header.value]) {
                  return <td> {dataItem[header.value]}</td>;
                } else {
                  return <td> --/-- </td>;
                }
              })}
          </tr>
        );
      }
    );

    return finalTableData;
  };

  return <>{renderTableData()}</>;
};

export default JobTableData;
